'use strict';

App.Models.PaymentCheckout = Backbone.Model.extend({
    
    classKey: 'paymentCheckout',
    
    urlRoot: function() {
        return `/payment/checkout${this.options.quantity ? `?quantity=${this.options.quantity}` : ''}`;
    },

    initialize: function(options) {
        this.options = options || {};
    },
    
    toViewJSON: function(options) {
        return this.toJSON();
    }
    
});
